import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=bd141750&scoped=true&"
import script from "./side-menu.vue?vue&type=script&lang=js&"
export * from "./side-menu.vue?vue&type=script&lang=js&"
import style0 from "./side-menu.vue?vue&type=style&index=0&id=bd141750&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd141750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd141750')) {
      api.createRecord('bd141750', component.options)
    } else {
      api.reload('bd141750', component.options)
    }
    module.hot.accept("./side-menu.vue?vue&type=template&id=bd141750&scoped=true&", function () {
      api.rerender('bd141750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/side-menu.vue"
export default component.exports